import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getActiveOwners,
  getAllTemplate,
  getGridDataByModuleKey,
  getUser,
} from '../../redux/selector';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import CampaignForm from './campaignForm';
import { useLocation, useNavigate } from 'react-router-dom';
import { validationSchemaCampaign } from './validationSchema';
import { initValueCampaign } from '../../shared/initials';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import {
  campaignInputData,
  dropdownPayloadCampaignContact,
  dropdownPayloadCampaignLead,
} from '../../shared/constants';

const AddCampaignForm = () => {
  const campaignData = initValueCampaign;
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(stateData, 'campaignList');
  const userInfo = useSelector(getUser);
  console.log('userInfo', userInfo);
  // Update owner in initValueLead if it is an empty string
  if (!campaignData.owner) {
    campaignData.owner = userInfo?.user?.display_name;
    campaignData.ownerId = userInfo?.user?.userId;
  }
  const [formData, setFormData] = useState(campaignData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [imagefile, setImageFile] = useState(null);
  const owner = useSelector(getActiveOwners);
  const [loading, setLoading] = useState(storeLoading);
  const [imageUploadStatus, setImageUploadStatus] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const gridData = useSelector(getGridDataByModuleKey('campaignList'));
  const [templateList, setTemplateList] = useState([]);
  const templates = useSelector(getAllTemplate);

  const fetchTemplatesByModule = (selectedModule) => {
    setLoading(true);

    // Filter from the already fetched templates in Redux
    const filtered = templates?.filter((template) => template.associatedModule === selectedModule);

    setTemplateList(filtered || []);
    setLoading(false);
  };

  const handleCloseAddForm = () => {
    navigate('/campaigns');
  };

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const saveUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id.data, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Campaigns');
      setImageUploadStatus(status);
    }
  };

  const editUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id, {
        type: imagefile.type,
      });
      let status = await apiServices.uploadLeadImageCRM(newFile, 'Campaigns');
      setImageUploadStatus(status);
    }
  };

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleSubmit = async (formData) => {
    try {
      // Convert scheduledDateTime to UTC
      const updatedFormData = {
        ...formData,
        scheduledDateTime: formData?.scheduledDateTime
          ? new Date(formData.scheduledDateTime).toISOString()
          : formData.scheduledDateTime,
        ...(formData?.type === 'edit' && { campaignStatus: 'Active' }),
      };

      await validationSchemaCampaign.validate(updatedFormData, {
        abortEarly: false,
      });

      handleFormSubmit(updatedFormData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const updateList = async (msg, id) => {
    setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });

    navigate('/campaigns');

    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({
      //     key: "campaignList",
      //     inputData: campaignInputData,
      //   })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Campaign',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'campaignDropdownLead',
          inputData: dropdownPayloadCampaignLead,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'campaignDropdownContact',
          inputData: dropdownPayloadCampaignContact,
        })
      );
      if (formData.from === 'view') {
        navigate(
          `/campaigns/viewCampaign?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
        );
      } else {
        navigate('/campaigns');
      }
    } catch (error) {
      console.error('Failed to fetch and update Campaign:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleFormSubmit = (formData) => {
    setLoading(true);
    if (formData.type === 'add') {
      apiServices
        .createCampaignList(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            saveUploadImage(response);
            updateList('Campaign Created Successfully!',id);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code
            const status = error.response.status;

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
          }
          setLoading(false);
        });
    } else {
      editUploadImage(formData.id);
      apiServices
        .updateCampaignList(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Campaign Updated Successfully!');
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          if (error.response && error.response.data && error.response.data.errors) {
            const errors = error.response.data.errors;
            // Extract HTTP status code
            const status = error.response.status;

            // Loop through each error type (e.g., "EndDate") and display its messages
            Object.keys(errors).forEach((errorType) => {
              const errorMessages = errors[errorType];
              errorMessages.forEach((errorMessage) => {
                // Display each error message in the toaster
                toast.error(` ${errorMessage}`, {
                  position: 'top-right',
                });
              });
            });
          } else {
          }
          setLoading(false);
        });
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'campaignTypeId') {
      setFormData({
        ...formData,
        campaignTypeId: selectedId,
        campaignType: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'statusId') {
      setFormData({
        ...formData,
        statusId: selectedId,
        status: selectedValue,
      });
      setFormEdited(true);
    }
    if (name === 'campaignFor') {
      setFormData((prev) => ({
        ...prev,
        campaignFor: selectedValue,
        templateId: '', // Reset here instead of separate call
      }));
      setSelectedOptions((prev) => ({
        ...prev,
        templateId: null,
      }));
      fetchTemplatesByModule(selectedValue); // Filter from Redux
      setFormEdited(true);
    } else if (name === 'templateId') {
      setFormData({
        ...formData,
        templateId: selectedId,
        // status: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'senderEmail') {
      setFormData({
        ...formData,
        senderEmail: selectedId,
        senderName: selectedValue,
      });

      setFormEdited(true);
    }
  };

  const handleDateTime = (e) => {
    const newValue = e.target.value;

    setFormData((prev) => ({
      ...prev,
      scheduledDateTime: newValue,
    }));

    // Clear the error if valid
    setErrorMsg((prev) => {
      const updatedErrors = { ...prev };
      const selectedDate = new Date(newValue);
      const now = new Date();
      const minAllowedTime = new Date(now.getTime() + 15 * 60 * 1000);

      if (selectedDate > minAllowedTime) {
        delete updatedErrors.scheduledDateTime;
      }

      return updatedErrors;
    });

    setFormEdited(true);
  };

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('addCampaign') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editCampaign') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  useEffect(() => {
    if (formData?.campaignFor && formData?.type === 'edit') {
      fetchTemplatesByModule(formData.campaignFor);
    }
  }, [formData?.campaignFor, formData?.type]);

  return (
    <>
      {/* {loading && <Loader />} */}
      <div className="addlead_container">
        <div className="viewHeader viewshadow">
          <HeaderProfileBlock
            localData={formData}
            moduleName={'Campaign'}
            uploadFile={handleUploadImage}
          />

          <div className="rightAction">
            <button
              type="button"
              className="btn btn-outline-primary"
              data-bs-dismiss="modal"
              onClick={handleCloseAddForm}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                handleSubmit(formData);
              }}
              disabled={loading || (formData?.type === 'edit' && !formEdited)}
            >
              {loading && (
                <>
                  {' '}
                  <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                </>
              )}
              {loading ? 'Loading...' : 'Save'}
            </button>
          </div>
        </div>
        <CampaignForm
          formData={formData}
          selectedOptions={selectedOptions}
          handleSubmit={handleSubmit}
          handleChangeForm={handleChangeForm}
          handleChange={handleChange}
          errormsg={errormsg}
          handleDateTime={handleDateTime}
          templateList={templateList}
        />
      </div>
    </>
  );
};

export default AddCampaignForm;
